/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-22 19:18:22
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {DeclareMaintenanceDOI} from "./api/declareMaintenanceApi";
import DeclareMaintenanceService from "./service/declareMaintenanceService";
import './declareMaintenance.less';

@Component({name: 'declare-maintenance'})
export default class DeclareMaintenance extends BasicSearchPage<DeclareMaintenanceService, DeclareMaintenanceDOI.RowDataI, DeclareMaintenanceDOI.QueryRowDataParamsI> {
    checkBoxShow = true
    @override
    renderHead(h) {
        return <div></div>
    }
    // rowData = [{ops_number:'1'}]
	@override
	loadService () {
		this.service = new DeclareMaintenanceService(this)
	}
}